import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './styles.module.scss';

export interface IIconButtonProps extends HTMLAttributes<HTMLButtonElement> {
  icon: React.ReactElement;
}

const IconButton = ({ icon, className = '', ...buttonProps }: IIconButtonProps) => {
  return (
    <button
      onKeyDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.preventDefault()}
      className={classNames(styles.iconButton, className)}
      {...buttonProps}
    >
      {icon}
    </button>
  );
};

export default IconButton;
